import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Geometri } from "../../models/karta-models";
import { KartgeometriVirkeskopDrivningspunktRemapper } from "../../utils/KartgeometriVirkeskopDrivningspunktRemapper";
import { GeometryBaseCommand } from "./GeometryBaseCommand";

export class AddOrUpdateGeometryCommand extends GeometryBaseCommand {
    guid: string;
    typ: string;
    wkt: string;
    subtyp1: string;
    subtyp2: string;
    subtyp3: string;
    anteckning: string;
    karttext: string;
    tillganglighetsklass: string;
    hansynAtgardTyp: string;
    externNyckel: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddOrUpdateGeometryCommand";

    constructor(guid: string, geometri: Geometri, virkeskopskontraktGuid?: string, virkeskopsatgardGuid?: string) {
        super(AddOrUpdateGeometryCommand.$type, CommandType.Replace);
        this.guid = guid;
        this.virkeskopskontraktGuid = virkeskopskontraktGuid;
        this.virkeskopsatgardGuid = virkeskopsatgardGuid;
        this.typ = geometri.parentType;
        this.wkt = geometri.mapGeometry.wkt;
        this.subtyp1 = geometri.kartgeometri.subtyp1;
        this.subtyp2 = geometri.kartgeometri.subtyp2;
        this.subtyp3 = geometri.kartgeometri.subtyp3;
        this.anteckning = geometri.kartgeometri.anteckning;
        this.tillganglighetsklass = geometri.kartgeometri.tillganglighetsklass;
        this.karttext = geometri.kartgeometri.karttext;
        this.hansynAtgardTyp = geometri.kartgeometri.hansynAtgardTyp;
        this.externNyckel = geometri.kartgeometri.externNyckel;
        KartgeometriVirkeskopDrivningspunktRemapper.remapToBackEndModelSingle(this);
    }
}
